import hqConfig from './config/hq';
import appConfig from './config/app';
import academyConfig from './config/academy';
import marketingConfig from './config/marketing';
import { getEnv } from '../env';

const configForEnv = (env, dimension) => {
  if (dimension === 'hq') {
    return hqConfig[env];
  }

  if (dimension === 'app') {
    return appConfig[env];
  }

  if (dimension === 'academy') {
    return academyConfig[env];
  }

  console.log('failed to find Okta config');

  return {};
};
const getMarketingConfig = (env, dimension) => {
  if (dimension === 'hq') {
    return {};
  }

  if (dimension === 'app') {
    return marketingConfig[env];
  }

  console.log('failed to find Okta config');

  return {};
};

const OKTA_TESTING_DISABLEHTTPSCHECK = false;
const BASENAME = process.env.PUBLIC_URL || '';
const REDIRECT_URI = `${window.location.origin}/auth/login/callback`;
const USE_INTERACTION_CODE = false;

const { env, dimension } = getEnv();

const envConfig = configForEnv(env, dimension);
const marketingConfigEnvConfig = getMarketingConfig(env, dimension);

const tokenStorageProvider = {
  getItem: key => window.localStorage.getItem(key),
  setItem: (key, value) => {
    if (!value || value === '{}') {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, value);
  },
  removeItem: key => window.localStorage.removeItem(key),
};

const tokenManager = {
  storage: tokenStorageProvider,
};

const config = {
  marketingOidc: {
    ...marketingConfigEnvConfig,
    redirectUri: `${window.location.origin}/auth/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    useInteractionCode: USE_INTERACTION_CODE,
    ignoreLifetime: true,
    decodeAccessTokens: true,
    brandName: 'Guesty',
    tokenManager,
  },
  oidc: {
    ...envConfig,
    ...(window.location.pathname === '/auth/impersonate' &&
      envConfig.backofficeIssuer && {
        issuer: envConfig.backofficeIssuer,
      }),
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    useInteractionCode: USE_INTERACTION_CODE,
    ignoreLifetime: true,
    decodeAccessTokens: true,
    brandName: 'Guesty',
    tokenManager,
  },
  app: {
    basename: BASENAME,
  },
};

export default config;
